import React from "react";
import "../css/home.css"; // Reusing some styles if possible, or creating a simple one

function Blogs() {
  return (
    <div className="skill-exp-page" style={{ textAlign: "center", paddingTop: "100px", minHeight: "80vh" }}>
      <h1>BLOGS</h1>
      <div className="container" style={{ justifyContent: "center" }}>
        <p className="highlight" style={{ fontSize: "2rem" }}>Coming Soon...</p>
      </div>
    </div>
  );
}

export default Blogs;
